<template>
<router-view></router-view>

</template>

<script>


</script>

<style>

@font-face {
    font-family: 'Oswald';
    src: url('/fonts/Oswald/Oswald-Regular.woff2') format('woff2'),
        url('/fonts/Oswald/Oswald-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;

    font-family: 'Oswald';
    src: url('/fonts/Oswald/Oswald-Regular.eot');
    src: url('/fonts/Oswald/Oswald-Regular.eot?#iefix') format('embedded-opentype'),
        url('/fonts/Oswald/Oswald-Regular.woff2') format('woff2'),
        url('/fonts/Oswald/Oswald-Regular.woff') format('woff'),
        url('/fonts/Oswald/Oswald-Regular.ttf') format('truetype'),
        url('/fonts/Oswald/Oswald-Regular.svg#Oswald-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

h1,h2,h3,h4,h5,h6{
    font-family: Oswald;
}


</style>
